import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterLink, RouterModule } from '@angular/router';
import { CardTransactionsListComponent } from './card-transactions-list/card-transactions-list.component';
import { CardListComponent } from './card-list/card-list.component';
import { BankTransactionsListComponent } from './bank-transactions-list/bank-transactions-list.component';
import { FormsModule } from '@angular/forms';
import { RefundModalComponent } from './refund-modal/refund-modal.component';
import { DebtsComponent } from './debts/debts.component';
import { ReturnModalComponent } from './return-modal/return-modal.component';
import { BlacklistUsdcComponent } from './blacklist-usdc/blacklist-usdc.component';
import { BlacklistIbansComponent } from './blacklist-ibans/blacklist-ibans.component';
import { BlacklistPhoneNumbersComponent } from './blacklist-phone-numbers/blacklist-phone-numbers.component';
import { WhitelistUsersComponent } from './whitelist-users/whitelist-users.component';
import { OpeningFeesComponent } from './opening-fees/opening-fees.component';
import { RecipientsListComponent } from './recipients-list/recipients-list.component';
import { CreateTransferComponent } from './create-transfer/create-transfer.component';
import { UserLogsComponent } from './user-logs/user-logs.component';
import { UserLimitsComponent } from './user-limits/user-limits.component';
import { CryptoRecipientsListComponent } from './crypto-recipients-list/crypto-recipients-list.component';
import { BlacklistUserComponent } from './blacklist-user/blacklist-user.component';
import { RevolupayUserComponent } from './revolupay-user/revolupay-user.component';
import { SolanaWalletCardComponent } from './solana-wallet-card/solana-wallet-card.component';
import { SecurityModalComponent } from './security-modal/security-modal.component';
import { CreateB2bUserModalComponent } from './create-b2b-user-modal/create-b2b-user-modal.component';
import { SettlementWalletsComponent } from './settlement-wallets/settlement-wallets.component';
import { ClosedUsersWithBalanceComponent } from './closed-users-with-balance/closed-users-with-balance.component';

@NgModule({
  declarations: [
    NavbarComponent,
    CardTransactionsListComponent,
    CardListComponent,
    BankTransactionsListComponent,
    RefundModalComponent,
    DebtsComponent,
    ReturnModalComponent,
    BlacklistUsdcComponent,
    BlacklistIbansComponent,
    BlacklistPhoneNumbersComponent,
    WhitelistUsersComponent,
    OpeningFeesComponent,
    RecipientsListComponent,
    CreateTransferComponent,
    UserLogsComponent,
    UserLimitsComponent,
    CryptoRecipientsListComponent,
    BlacklistUserComponent,
    RevolupayUserComponent,
    SolanaWalletCardComponent,
    SecurityModalComponent,
    CreateB2bUserModalComponent,
    SettlementWalletsComponent,
    ClosedUsersWithBalanceComponent,
  ],
  imports: [CommonModule, RouterLink, RouterModule, FormsModule],
  exports: [
    NavbarComponent,
    CardTransactionsListComponent,
    CardListComponent,
    BankTransactionsListComponent,
    RefundModalComponent,
    DebtsComponent,
    ReturnModalComponent,
    BlacklistUsdcComponent,
    BlacklistIbansComponent,
    BlacklistPhoneNumbersComponent,
    WhitelistUsersComponent,
    OpeningFeesComponent,
    RecipientsListComponent,
    CreateTransferComponent,
    UserLogsComponent,
    UserLimitsComponent,
    CryptoRecipientsListComponent,
    BlacklistUserComponent,
    RevolupayUserComponent,
    SolanaWalletCardComponent,
    SecurityModalComponent,
    CreateB2bUserModalComponent,
    SettlementWalletsComponent,
    ClosedUsersWithBalanceComponent,
  ],
})
export class ComponentsModule {}



